import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { RepairPaymentBatchInterface } from '../interfaces/repair-payment-batch.interface';
import { RepairPaymentCreateDto } from './repair-payment-create.dto';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsOptional, IsString, ValidateNested } from 'class-validator';
import { RepairPaymentInterface } from '../interfaces/repair-payment.interface';
import { RepairPaymentUpdateDto } from './repair-payment-update.dto';

export class RepairPaymentBatchDto implements RepairPaymentBatchInterface {
  @ApiPropertyOptional({
    type: () => RepairPaymentCreateDto,
    title: 'Job Repair',
    nullable: true,
    isArray: true,
    description: 'Insert bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => RepairPaymentCreateDto)
  insert!: RepairPaymentCreateDto[];

  @ApiPropertyOptional({
    type: () => RepairPaymentUpdateDto,
    title: 'Job Repair Bulk Update',
    nullable: true,
    isArray: true,
    description: 'Update bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => RepairPaymentUpdateDto)
  update!: RepairPaymentUpdateDto[];

  @ApiProperty({
    type: () => String,
    nullable: true,
    isArray: true,
    title: 'Delete Bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  delete!: RepairPaymentInterface['id'][]; //string[];
}
